import PropTypes from 'prop-types';
import { Link, useParams } from 'react-router-dom';

// material-ui
import { ButtonBase } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

// project import
import Logo from './Logo';
import config from 'config';
import { activeItem } from 'store/reducers/appreducer';

const LogoSection = ({ sx, to }) => {
  const { organizationName } = useParams();
  const { defaultId, defaultIdTitle } = useSelector((state) => state.appreducer);
  const dispatch = useDispatch();
  return (
    <ButtonBase
      disableRipple
      component={Link}
      onClick={() => dispatch(activeItem({ openItem: [defaultId], openItemTitle: defaultIdTitle }))}
      to={!to ? `/${organizationName}/device-info` : to}
      sx={sx}
    >
      <Logo organizationName={organizationName} />
    </ButtonBase>
  );
};

LogoSection.propTypes = {
  sx: PropTypes.object,
  to: PropTypes.string
};

export default LogoSection;
